import { render } from "./TrainingDocumentList.vue?vue&type=template&id=49900d39"
import script from "./TrainingDocumentList.vue?vue&type=script&lang=ts"
export * from "./TrainingDocumentList.vue?vue&type=script&lang=ts"
script.render = render

export default script